<template>
  <el-form :rules="rules" :model="forgetForm" ref="forgetForm" class="forget-container" label-position="left" label-width="0px" v-loading="loading">
    <h3 class="forget">{{$t("forget.title")}}</h3>
    <p class="hint">{{$t("forget.hint")}}</p>
    <el-form-item prop="email">
      <el-input type="text" v-model="forgetForm.email" auto-complete="off" :placeholder="$t('register.emailRule')">
      </el-input>
    </el-form-item>
    <!-- <el-checkbox class="login_remember" v-model="checked" label-position="left">{{$t("login.remember")}}</el-checkbox>
    <br>-->

    <el-form-item style="width: 100%">
      <el-button type="primary" @click.native.prevent="submitClick" style="width: 100%">{{$t("forget.button")}}
      </el-button>
    </el-form-item>
    <el-button class="el-icon-caret-left" type="text" @click="jump('/')">{{$t("forget.return")}}</el-button>

  </el-form>
</template>
<script>
import {
  postRequest
} from "../utils/api";
import {
  putRequest
} from "../utils/api";
import {
  isIntersect
} from "../utils/utils";
export default {
  data() {
    return {
      rules: {
        email: [{
          required: true,
          message: this.$t("forget.emailRule"),
          trigger: "blur"
        },
        {
          pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: this.$t("forget.refill")
        }
        ],
      },
      checked: true,
      forgetForm: {
        email: ""

      },
      loading: false
    };
  },
  methods: {
    jump(path) {
      this.$router.replace(path);
    },
    submitClick: function () {
      var _this = this;
      this.loading = true;
      postRequest("/forget", {
        email: this.forgetForm.email

      }).then(
        resp => {
          _this.loading = false;
          if (resp.status == 200) {
            //成功
            var json = resp.data;
            if (json.status == "success") {
              _this.$i18n.locale = json.locale;

              _this.$alert(this.$t("forget.alertMsg"), this.$t("forget.success"));
              _this.$router.replace({ path: "/" });

              // _this.$router.replace({ 
              //     path: "/passwordReset",
              //     query: {
              //         email: this.forgetForm.email
              //     }
              //     });
            } else {
              _this.$alert(this.$t("forget.not_email"), this.$t("forget.fail"));
            }
          } else {
            //失败
            _this.$alert(this.$t("forget.not_email"), this.$t("forget.fail"));
          }
        },
        resp => {
          _this.loading = false;
          _this.$alert(this.$t("forget.server_not_found"), this.$t("forget.fail"));
        }
      );
    }
  }
};
</script>
<style scoped>
.forget-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.forget_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.hint {
  color: gray;
  font-size: 75%;
}
</style>


// WEBPACK FOOTER //
// src/components/Forget.vue